import errPage from '../../pages/refund/views/pages/errPage.vue'
const work = (resolve) => { // 领导组首页
    import('../../pages/refund/views/work/index.vue').then((module) => {
        resolve(module)
    })
};
const leaderAttention = (resolve) => { // 领导组关注页面
    import('../../pages/refund/views/leader/attention.vue').then((module) => {
        resolve(module)
    })
};
const leaderList = (resolve) => { // 领导退货数据页面
    import('../../pages/refund/views/leader/leaderList.vue').then((module) => {
        resolve(module)
    })
};
const leaderDetail = (resolve) => { // 领导组列表页面
    import('../../pages/refund/views/leader/leaderDetail.vue').then((module) => {
        resolve(module)
    })
};

export default [{
    path: '/refund/leadList',
    component: () =>
        import('../../pages/refund/views/leader/leadList1.vue'),
    meta: {
        title: '退货数据'
    }
},

{
    path: '/refund/evaluationDetails',
    component: () =>
        import('../../pages/refund/views/pages/evaluationDetails.vue'),
    meta: {
        title: '评价详情'
    }
},

{
    path: '/refund/itinerary',
    component: () =>
        import('../../pages/refund/views/pages/itinerary.vue'),
    meta: {
        title: '行程单'
    }
},

{
    path: '/refund/associatedOrder',
    component: () =>
        import('../../pages/refund/views/associatedOrder.vue'),
    meta: {
        title: '关联退货单'
    }
},

// 退货列表
{
    path: '/refund/refundList',
    name: 'RefundList',
    component: () =>
        import('../../pages/refund/views/refundList/refundList.vue'),
    meta: {
        title: '退货列表',
        keepAlive: true
    }
},
// 扫一扫
{
    path: '/refund/scan',
    component: () =>
        import('../../pages/refund/views/components/scan.vue'),
    meta: {
        title: '扫一扫'
    }
},
// 新退货数据看板
{
    path: '/refund/newRefund',
    component: () =>
        import('../../pages/refund/views/index.vue'),
    meta: {
        title: '',
    }
},
{
    path: '/refund/returnerDetails',
    component: () =>
        import('../../pages/refund/views/pages/detailsReturner.vue'),
    meta: {
        title: '退货人详情'
    }
    },
    {
        path: '/refund/purchaserDetails',
        component: () =>
            import('../../pages/refund/views/pages/purchaserDetails.vue'),
        meta: {
            title: '购买人详情'
        }
    },

// 申诉反馈审核
{
    path: '/refund/appealFeedbackReview',
    component: () =>
        import('../../pages/refund/views/pages/appealFeedbackReview.vue'),
    meta: {
        title: '审核'
    }
},
{
    path: '/refund/statisticalAnalysis',
    name: 'statisticalAnalysis',
    component: () =>
        import('../../pages/refund/views/statisticalAnalysis/index.vue'),
    meta: {
        title: '退货统计分析',
        keepAlive: true
    }
},
{
    path: '/refund/sendBack',
    component: () =>
        import('../../pages/refund/views/pages/sendback.vue'),
    meta: {
        title: '退回'
    }
},
{
    path: '/refund/supervise',
    component: () =>
        import('../../pages/refund/views/pages/supervise.vue'),
    meta: {
        title: '督办'
    }
},
{
    path: '/refund/leader',
    component: () =>
        import('../../pages/refund/views/leader/index.vue'),
    meta: {
        title: '退货处置平台'
    }
},
{
    path: '/refund/manageList',
    name: 'manageList',
    component: () =>
        import('../../pages/refund/views/manageList/index.vue'),
    meta: {
        keepAlive: true,
        title: '退货列表'
    }
},
{
    path: '/refund/refundDetail',
    component: () =>
        import('../../pages/refund/views/refundDetail/index.vue'),
    meta: {
        title: '退货详情',
    }
},

{
    path: '/refund/overseelist',
    component: () =>
        import('../../pages/refund/views/pages/refundOversee.vue'),
    meta: {
        title: '督办列表'
    }
},
{
    path: '/refund/oversee',
    component: () =>
        import('../../pages/refund/views/pages/overseeDetail.vue'),
    meta: {
        title: '督办详情'
    }
},
{
    path: '/refund/submittedSuccessfully',
    component: () =>
        import('../../pages/refund/views/pages/submittedSuccessfully.vue'),
    meta: {
        title: '提交结果'
    }
},
{
    path: '/refund/overseefeedback',
    component: () =>
        import('../../pages/refund/views/pages/overseeFeedback.vue'),
    meta: {
        title: '督办详情'
    }
},

{
    path: '/refund/createdRefund',
    component: () =>
        import('../../pages/refund/views/pages/createRefund.vue'),
    meta: {
        title: '录入退货单'
    }
},
{
    path: '/refund/secondRefund',
    component: () =>
        import('../../pages/refund/views/pages/secondRefund.vue'),
    meta: {
        title: '录入退货单'
    }
},
{
    path: '/refund/lookup',
    component: () =>
        import('../../pages/refund/views/pages/lookup.vue'),
    meta: {
        title: '查找销售企业'
    }
},
{
    path: '/refund/errPage',
    component: errPage,
    meta: {
        title: ''
    }
},

{
    path: '/refund/feedbackPickupInformation',
    component: () =>
        import('../../pages/refund/views/feedbackPickupInformation/index.vue'),
    meta: {
        title: '反馈取货信息'
    }
},

{
    path: '/refund/pickupInformationDetails',
    component: () =>
        import('../../pages/refund/views/pages/pickupInformationDetails.vue'),
    meta: {
        title: '取货信息详情'
    }
},
{
    path: '/refund/feedbackAddress',
    component: () =>
        import('../../pages/refund/views/feedbackAddress'),
    meta: {
        title: '反馈退货地址'
    }
},
{
    path: '/refund/disposalProgressDetail',
    name: 'disposalProgressDetail',
    component: () =>
        import('../../pages/refund/views/disposalProgressDetail/index.vue'),
    meta: {
        title: '处置进度',
        keepAlive: true
    }
},
{
    path: '/refund/agreeAccept',
    component: () =>
        import('../../pages/refund/views/agreeAccept/index.vue'),
    meta: {
        title: '同意受理'
    }
},

{
    path: '/refund/agreeAcceptDetail',
    component: () =>
        import('../../pages/refund/views/pages/agreeAccept.vue'),
    meta: {
        title: '同意受理'
    }
},
{
    path: '/refund/feedbackDisposalResults',
    component: () =>
        import('../../pages/refund/views/feedbackDisposalResults/index.vue'),
    meta: {
        title: '反馈处置结果'
    }
},

{
    path: '/refund/feedbackDisposalResultsDetail',
    component: () =>
        import('../../pages/refund/views/pages/feedbackDisposalResultsDetail.vue'),
    meta: {
        title: '处置结果'
    }
},
{
    path: '/refund/appealFeedback',
    component: () =>
        import('../../pages/refund/views/pages/appealFeedback.vue'),
    meta: {
        title: '申诉反馈'
    }
},

{
    path: '/refund/appealDetails',
    component: () =>
        import('../../pages/refund/views/pages/appealDetails.vue'),
    meta: {
        title: '申诉详情'
    }
},
{
    path: '/refund/worker',
    component: work,
    meta: {
        title: '退货'
    }
},
{
    path: '/refund/leaderAttention',
    component: leaderAttention,
    meta: {
        title: '我的关注'
    }
},
{
    path: '/refund/leaderList',
    component: leaderList,
    meta: {
        title: '退货数据',
	    unwantedSetTitle: true
    }
},
{
    path: '/refund/leaderDetail',
    component: leaderDetail,
    meta: {
        // keepAlive: true,
        title: '退货列表'
    }
},
{
    path: '/refund/noHandel',
    component: () =>
        import('../../pages/refund/views/pages/noHandle.vue'),
    meta: {
        title: '不予受理'
    }
},
{
    path: '/refund/accpet',
    component: () =>
        import('../../pages/refund/views/pages/accpet.vue'),
    meta: {
        title: '变更退货方式',
	    unwantedSetTitle: true
    }
},
{
    path: '/refund/feebackExpress',
    component: () =>
        import('../../pages/refund/views/pages/feebackExpress.vue'),
    meta: {
        title: '反馈退货地址'
    }
},

{
    path: '/refund/returnAddress',
    component: () =>
        import('../../pages/refund/views/pages/returnAddress.vue'),
    meta: {
        title: '退货地址'
    }
},
{
    path: '/refund/flow',
    component: () =>
        import('../../pages/refund/views/pages/flow.vue'),
    meta: {
        title: '转办'
    }
},
{
    path: '/refund/audit',
    component: () =>
        import('../../pages/refund/views/pages/audit.vue'),
    meta: {
        title: '退货单上报'
    }
},
// 上报的审核页面
{
    path: '/refund/reportReview',
    component: () =>
        import('../../pages/refund/views/pages/reportReview.vue'),
    meta: {
        title: '审核'
    }
},
// 处置结果审核
{
    path: '/refund/disposalResultReview',
    component: () =>
        import('../../pages/refund/views/pages/disposalResultReview.vue'),
    meta: {
        title: '审核'
    }
},
{
    path: '/refund/express',
    component: () =>
        import('../../pages/refund/views/pages/express.vue'),
    meta: {
        title: '反馈快递单号'
    }
},

{
    path: '/refund/noReview',
    component: () =>
        import('../../pages/refund/views/pages/noReview.vue'),
    meta: {

    }
},
{
    path: '/refund/logistics',
    component: () =>
        import('../../pages/refund/logistics/index.vue'),
    meta: {
        title: '物流信息'
    }
},
// {
//     path: '/refund/Logistics',
//     component: () =>
//         import('../../pages/refund/views/refundDetail/Logistics.vue'),
//     meta: {
//         title: '运单追踪'
//     }
// },
{
    path: '/refund/feedReulst',
    component: () =>
        import('../../pages/refund/views/pages/feedbackVerify.vue'),
    meta: {
        title: '反馈验证结果'
    }
},
{
    path: '/refund/search',
    component: () =>
        import('../../pages/refund/views/leader/search.vue'),
    meta: {
        title: '搜索'
    }
},
{
    path: '/refund/salesReturnCenter',
    component: () =>
        import('../../pages/refund/views/statisticalAnalysis/salesReturnCenter.vue'),
    meta: {
        title: '退货统计分析'
    }
},
{
    path: '/refund/cityAreaRefundList',
    component: () =>
        import('../../pages/refund/views/statisticalAnalysis/refundAreaList/cityAreaRefundList.vue'),
    meta: {
        title: '',
        // keepAlive:true
    }
},
{
    path: '/refund/allCounty',
    component: () =>
        import('../../pages/refund/views/statisticalAnalysis/refundAreaList/allCounty.vue'),
    meta: {
        title: '全部区县'
    }
},
{
    path: '/refund/commonList',
    component: () =>
        import('../../pages/refund/views/statisticalAnalysis/commonList.vue'),
    meta: {
        title: '退货列表',
        // keepAlive: true
    }
}
];
